import { configureStore } from "@reduxjs/toolkit";
import persistedReducer from "./reducers/index";

// project import
// import reducers from './reducers';

// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

// Create store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});

const { dispatch } = store;

export { store, dispatch };
